module.exports = __webpack_public_path__ + "static/media/full-house-lg.7455df67.png";